export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6409.1b5f1c33.jpg";